import { History } from "history";
import React from "react";
import { Entity } from "src/documentUpload/types";
import "./EntityListRow.scss";

export interface EntityListRowProps {
  history: History;
  entity: Entity;
}

export const EntityListRow: React.SFC<EntityListRowProps> = ({
  entity,
  history
}) => {
  const viewEntity = () => {
    if (entity.entityId) {
      history.push(`/entity/${entity.entityId}`);
    }
  };

  return (
    <div className="Entity__list__row" onClick={viewEntity}>
      <div className="Entity__list__row__item">
        <span className="Entity__list__row__item__content">{entity.name}</span>
      </div>
      <div className="Entity__list__row__item">
        <span className="Entity__list__row__item__content">{entity.city}</span>
      </div>
      <div className="Entity__list__row__item">
        <span className="Entity__list__row__item__content">
          {entity.country}
        </span>
      </div>
      <div className="Entity__list__row__item">
        <span className="Entity__list__row__item__content">
          {entity.industry}
        </span>
      </div>
      <div className="Entity__list__row__item">
        <span className="Entity__list__row__item__content">
          {entity.clientEntityID}
        </span>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/entityList/EntityListRow.tsx